import React from 'react';
import { Breadcrumb } from 'antd';
import { BreadcrumbItemProps as BreadcrumbItemPropsProps } from 'antd/lib/breadcrumb/BreadcrumbItem';

export type BreadcrumbItemProps = BreadcrumbItemPropsProps;

const ProBreadcrumbItem: React.FC<BreadcrumbItemProps> = (props) => {
  const { children, ...resProps } = props;

  return <Breadcrumb.Item {...resProps}>{children}</Breadcrumb.Item>;
};

export default ProBreadcrumbItem;
